import React from 'react'
import type { Coupon as CouponType } from 'shared/types'
import { media } from 'app/assets/styles'
//import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { Coupon } from 'app-v2/shared/features/coupon'
//import { Coupon } from 'app/common/coupon'
//import { media } from 'app/assets/styles'

//const { lightGrey, grey, shadow } = colors

type Props = {
    coupons: Array<CouponType>,
    onClick?: (coupon?: CouponType) => void,
    fromEcommerce?: boolean
}

const CouponsSlider = (props: Props) => {
    const { coupons, onClick, fromEcommerce = false } = props
    return (
        <Wrapper>
            <OffersContainer>
                {coupons.map((coupon: CouponType, index) => {
                    const { id, ...couponProps } = coupon
                    const selectCoupon = !onClick
                        ? undefined
                        : () => onClick(coupon)
                    return (
                        <CouponContainer key={index}>
                            <Coupon
                                id={id}
                                {...couponProps}
                                selectCoupon={selectCoupon}
                                fromEcommerce={fromEcommerce}
                                coupon={coupon}
                            />
                        </CouponContainer>
                    )
                })}
            </OffersContainer>
        </Wrapper>
    )
}
//SLIDER
/*const Wrapper = styled.div`
    background-color: white;
    position: relative;
    border-radius: 12px;
    box-shadow: 0 0 15px ${shadow};
    box-sizing: border-box;
    padding: 15px;
    width: 100%;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    ${media.medium`
        width: calc(80% - 128px);
    `};
    ${media.large`
         width: 100%;
    `};
`

const OffersContainer = styled.div`
    display: flex;
    overflow-x: auto;
    ::-webkit-scrollbar {
        height: 6px;
        border-radius: 6px;
        background-color: ${lightGrey};
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${grey};
        border-radius: 6px;
    }
`*/

//LIST TWO BY TWO
const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    ${media.medium`
        width: 80%;
    `}
    ${media.large`
        width: calc(100% - 20px);
    `}
`

const OffersContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
`

const CouponContainer = styled.div`
    margin: 0 2px 10px;
`

export { CouponsSlider }
